import React from 'react';
import style from './style';
import clsx from "clsx";

const BackButton = ({back,title,icon,additionalClass}) => {
  const {classes} = style();
  return (
    <div onClick={back} className={clsx(classes.root,additionalClass)}>
      <img
        src={process.env.PUBLIC_URL + "/img/icons/arrow/arrow-back-long.svg"}
        alt="back"
        className={classes.arrowIcon}
      />
      {icon?<img
        src={process.env.PUBLIC_URL + icon}
        alt="back"
        className={classes.icon}
      />:<></>}
      <span className={classes.text}>
        {title}
      </span>
    </div>
  )
}

export default BackButton;